import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";
import Button from "../components/Button";
import Header from "../components/Header";
import { generalFaq, pricingFaq, leasesFaq } from "../data/faqData";
import iPhone1 from "../data/images/iphone-1.png";
import iPhone2 from "../data/images/iphone-2.png";
import aws from "../data/images/aws.png";
import stripe from "../data/images/stripe.png";
import netlify from "../data/images/netlify.png";
import firebase from "../data/images/firebase.png";
import google from "../data/images/google.png";
import { FaCheck } from "react-icons/fa";
import { FcClock } from "react-icons/fc";
import { GrDocumentText } from "react-icons/gr";
import { TbPigMoney } from "react-icons/tb";
import { LuCalendarCheck, LuUserSearch } from "react-icons/lu";
import { IoChatbubblesOutline } from "react-icons/io5";
import { FaMoneyBillTransfer } from "react-icons/fa6";
import { TfiAlarmClock } from "react-icons/tfi";
import { GiVacuumCleaner } from "react-icons/gi";
import { IoReceiptOutline } from "react-icons/io5";
import { RiNumber1, RiNumber2, RiNumber3, RiNumber4 } from "react-icons/ri";
import Faq from "../components/Faq";
import { ContactForm, Footer, HeadMetaTags } from "../components";
// import { useStateContext } from "../contexts/ContextProvider";

const Home = () => {
  // const { faqClicked, setFaqClicked } = useStateContext();
  const navigate = useNavigate();
  const location = useLocation();
  const isTracking =
    process.env.REACT_APP_GA_TRACKING === "true" ? true : false;

  useEffect(() => {
    if (isTracking) {
      ReactGA.send({
        hitType: "pageview",
        page: location.pathname + location.search,
      });
    }
    // eslint-disable-next-line
  }, [location]);

  const handleGAEvent = (category, action, label) => {
    if (isTracking) {
      ReactGA.event({
        category,
        action,
        label,
      });
    }
  };

  return (
    <div className="overflow-hidden">
      <HeadMetaTags />
      <section id="header" className="w-full">
        <Header />
      </section>
      <section
        id="home"
        className="w-screen h-screen min-h-[500px] bg-hero-background bg-right sm:bg-center
        bg-cover bg-no-repeat pb-20"
      >
        <div className="w-full text-center pt-36">
          <p className="text-3xl sm:text-5xl lg:text-7xl px-10">
            Roommates Made Simple.
          </p>
          <p className="flex justify-center text-xl sm:text-3xl mt-5 px-14">
            Collect rent, split bills, assign chores, and more.
          </p>
          <div className="mt-10">
            <Button
              background="bg-snappily-orange"
              text="text-white"
              opacity="bg-opacity-100"
              title="Get Started for Free"
              height="h-10"
              width="w-60"
              borderHover="hover:border-snappily-orange"
              customFunc={() => {
                navigate("/signup");
                handleGAEvent(
                  "Button Click",
                  "Clicked",
                  "Get Started for Free"
                );
              }}
            />
          </div>
          <div className="flex justify-center text-base mt-3">
            <div className="bg-white opacity-80 rounded-lg px-1">
              No credit card required.
            </div>
          </div>
        </div>
      </section>
      <section id="marquee" className="w-screen bg-blue-50 mb-5">
        <div className="flex justify-center text-2xl md:text-3xl pt-10">
          Proudly Powered By:
        </div>
        <div className="flex justify-evenly w-[800px] md:w-screen relative overflow-x-hidden">
          <div
            className="flex w-full justify-between animate-marquee whitespace-nowrap 
            py-12 px-20 xs:px-10 sm:px-10 md:px-10 lg:px-24"
          >
            <img src={aws} alt="Amazon Web Service Logo" className="h-12" />
            <img src={stripe} alt="Stripe Logo" className="h-12" />
            <img src={netlify} alt="Netlify Logo" className="h-12" />
            <img src={firebase} alt="Firebase Logo" className="h-12" />
            <img src={google} alt="Google Logo" className="h-12" />
          </div>
          <div
            className="flex justify-between w-[800px] md:w-screen absolute top-0 animate-marquee2 
            whitespace-nowrap py-12 px-20 xs:px-6 sm:px-10 md:px-14 lg:px-24"
          >
            <img src={aws} alt="Amazon Web Service Logo" className="h-12" />
            <img src={stripe} alt="Stripe Logo" className="h-12" />
            <img src={netlify} alt="Netlify Logo" className="h-12" />
            <img src={firebase} alt="Firebase Logo" className="h-12" />
            <img src={google} alt="Google Logo" className="h-12" />
          </div>
        </div>
      </section>
      <section className="w-screen relative">
        <div id="how-it-works" className="absolute -top-16"></div>
        <div className="grid justify-items-center text-center text-3xl sm:text-4xl pt-10 px-5">
          {/* <p className="">It's Property Management by the Room</p> */}
          <p className="">Splitting an Apartment Has Never Been Easier</p>
          {/* <p className="text-2xl text-gray-400 p-2">
            Splitting a house or apartment has never been easier.
          </p> */}
          <FcClock className="text-7xl mt-8" />
          <p className="text-2xl text-gray-500 mt-8">
            Snappily provides all the tools you need, in one powerful app.
          </p>
        </div>
        <div className="flex justify-center text-3xl mt-8">Features:</div>
        <div
          className="grid justify-items-center grid-cols-2 md:grid-cols-4 gap-x-5 gap-y-8 
          lg:text-2xl mt-8 mb-20 px-5"
        >
          <div className="grid justify-items-center text-center">
            <LuCalendarCheck className="text-3xl lg:text-6xl" />
            <div>Automated Rent Collection</div>
          </div>
          <div className="grid justify-items-center text-center">
            <GrDocumentText className="text-3xl lg:text-6xl" />
            <div>Optimized Leases for Every State</div>
          </div>
          <div className="grid justify-items-center text-center">
            <TbPigMoney className="text-3xl lg:text-6xl" />
            <div>Electronic Payments</div>
          </div>
          <div className="grid justify-items-center text-center">
            <IoChatbubblesOutline className="text-3xl lg:text-6xl" />
            <div>In-App Messaging</div>
          </div>
          <div className="grid justify-items-center text-center">
            <FaMoneyBillTransfer className="text-3xl lg:text-6xl" />
            <div>Split Bills with Roommates</div>
          </div>
          <div className="grid justify-items-center text-center">
            <TfiAlarmClock className="text-3xl lg:text-6xl" />
            <div>Rent is Due Notifications</div>
          </div>
          <div className="grid justify-items-center text-center">
            <GiVacuumCleaner className="text-3xl lg:text-6xl" />
            <div>Assign Chores</div>
          </div>
          <div className="grid justify-items-center text-center">
            <IoReceiptOutline className="text-3xl lg:text-6xl" />
            <div>Expense Tracking</div>
          </div>
        </div>
      </section>
      <section className="w-screen bg-gray-200 pb-20 relative">
        <div id="collecting-rent" className="absolute -top-16"></div>
        <div className="grid justify-items-center pt-14 px-5">
          <p className="text-center text-3xl">Collecting Rent is Easy</p>
          <p className="text-center text-xl mt-5 px-5">
            Roommates are automatically billed on the 1<sup>st</sup> of every
            month!
          </p>
          <div
            className="grid justify-items-center md:grid-cols-2 gap-y-5 md:gap-y-10 md:gap-x-20 
          text-base md:text-lg mt-10 px-10"
          >
            <div className="flex justify-center items-center">
              <FaCheck className="text-2xl text-snappily-orange mr-3" />
              <p className="w-60 md:w-80">
                Roommates can pay electronically via ACH, credit, or debit
              </p>
            </div>
            <div className="flex justify-center items-center ">
              <FaCheck className="text-2xl text-snappily-orange mr-3" />
              <p className="w-60 md:w-80">
                Late fees are automatically charged after grace period.
              </p>
            </div>
            <div className="flex justify-center items-center">
              <FaCheck className="text-2xl text-snappily-orange mr-3" />
              <p className="w-60 md:w-80">
                Automated reminder emails for late payments.
              </p>
            </div>
            <div className="flex justify-center items-center">
              <FaCheck className="text-2xl text-snappily-orange mr-3" />
              <p className="w-60 md:w-80">
                Roommates can manage their account from the tenant portal.
              </p>
            </div>
          </div>
        </div>
        <div className="flex justify-center mt-14">
          <Button
            background="bg-snappily-orange"
            text="text-white"
            opacity="bg-opacity-100"
            title="Get Started for Free"
            height="h-10"
            width="w-60"
            borderHover="hover:border-snappily-orange"
            customFunc={() => {
              navigate("/signup");
            }}
          />
        </div>
        <div className="flex justify-center mt-3">No credit card required.</div>
      </section>
      <section className="bg-white pb-20 relative">
        <div id="leases" className="absolute -top-16"></div>
        <div className="grid justify-items-center text-3xl pt-14 px-5">
          <p>Leases Are Simple</p>
          <GrDocumentText className="text-7xl mt-5" />
          <p className="text-center text-2xl mt-10 px-5">How it works:</p>
        </div>
        <div
          className="grid justify-items-center md:grid-cols-2 gap-y-5 md:gap-y-10 md:gap-x-10  
        text-lg mt-10 px-10"
        >
          <div className="flex justify-center">
            <RiNumber1 className="text-3xl mt-2 mr-3" />
            <p className="w-72 lg:w-96">
              Answer a few simple questions about your terms.
            </p>
          </div>
          <div className="flex justify-center">
            <RiNumber2 className="text-3xl mt-2 mr-3" />
            <p className="w-72 lg:w-96">
              Snappily generates a lease optimized for the laws in your State.
            </p>
          </div>
          <div className="flex justify-center">
            <RiNumber3 className="text-3xl mt-2 mr-3" />
            <p className="w-72 lg:w-96">
              Roommate receives an invite to view and electronically sign the
              lease.
            </p>
          </div>
          <div className="flex justify-center">
            <RiNumber4 className="text-3xl mt-2 mr-3" />
            <p className="w-72 lg:w-96">
              Once executed, both you and the tenant can download and print
              copies of the lease.
            </p>
          </div>
        </div>
      </section>
      <section className="bg-gray-200 pb-20 relative">
        <div id="finding-tenants" className="absolute -top-16"></div>
        <div className="grid justify-items-center text-3xl pt-14 px-5 relative">
          <p className="text-center">Find Qualified Roommates</p>
          <LuUserSearch className="text-7xl mt-5" />
          <p className="text-center text-xl absolute -bottom-20 px-10">
            Prospective roommates can browse for available rooms.
          </p>
        </div>
        <div className="grid justify-items-center md:grid-cols-2 mg:gap-x-5 mt-16">
          <div className="md:place-self-end md:pr-10">
            <img
              src={iPhone2}
              alt="publish rooms with snappily"
              width="360px"
            />
          </div>
          <div className="md:place-self-start md:pl-10 sm:mt-16">
            <img
              src={iPhone1}
              alt="publish rooms with snappily"
              width="300px"
            />
          </div>
        </div>
        <div className="flex justify-center text-2xl text-center mt-10 md:mt-0 px-10">
          Post Unlimited Rooms for FREE!
        </div>
        <div className="flex justify-center mt-5">
          <Button
            background="bg-snappily-orange"
            text="text-white"
            opacity="bg-opacity-100"
            title="Post A Room"
            height="h-10"
            width="w-60"
            borderHover="hover:border-snappily-orange"
            customFunc={() => {
              navigate("/signup?action=post");
            }}
          />
        </div>
        <div className="flex justify-center mt-3">No credit card required.</div>
      </section>
      {/* <section className="h-screen bg-white relative">
        <div id="pricing" className="absolute -top-16"></div>
        <div className="flex justify-center text-3xl pt-14 px-5">Pricing</div>
      </section> */}
      <section id="" className="w-screen relative">
        <div id="faq" className="absolute -top-20"></div>
        <div>
          <Faq
            generalFaq={generalFaq}
            leasesFaq={leasesFaq}
            pricingFaq={pricingFaq}
          />
        </div>
      </section>
      <section className="w-screen bg-gray-200 pt-10 pb-36 relative">
        <div id="contact" className="absolute -top-16"></div>
        <ContactForm />
      </section>
      <section>
        <Footer />
      </section>
    </div>
  );
};

export default Home;
